<template>
  <div id="app">
    <mobile-head v-if="showMobile" style="position: fixed; z-index: 99999999" :headHour="headHour" @returenText="returenText" ></mobile-head>
    <mian-head ref="mianhead" v-if="showPc"></mian-head>
<!--    <router-view/>-->
    <router-view v-if="showPage == 1" name="mobile" ></router-view>
    <router-view v-if="showPage == 2" name="pc" ></router-view>


    <mian-footer v-if="showPc"></mian-footer>
    <mobile-footer v-if="showMobile"></mobile-footer>
  </div>

</template>
<script>
  import mianHead from './components/mian-head'
  import mianFooter from './components/mian-footer'
  import mobileHead from './components/app-mian-head.vue'
  import mobileFooter from './components/app-mian-footer.vue'
  export default {
    name: "app",
    components:{
      mianHead,
      mianFooter,
      mobileHead,
      mobileFooter,
    },
    data() {
      return {
        showPage: '',
        showMobile: false,
        showPc: false,
        headHour: {},
      }
    },
    created() {
      this.getEquipment();
    },
    watch: {
    parentindex(newVal, oldVal){
      if (newVal > oldVal) {
        this.headHour = {
          top: "-80px"
        };
      } else {
        this.headHour = {
          top: "0px"
        };
      }
    }
  },
    methods:{
      returenText(item) {
      if (item.index > 0) {
        this.headHour = {
          top: "-80px"
        };
      } else {
        this.headHour = {
          top: "0px"
        };
      }
      // this.parentindex = item.index;
      // this.$refs.mySwiper.swiper.slideTo(item.index, 1000, true);

    },
    changeIndex(index) {
      this.activeIndex = index;
      // this.$refs.childSwiper.swiper.slideTo(index, 1000, true);
    },
    slideParentChangeStart() {
      this.parentindex = this.$refs.mySwiper.swiper.realIndex;
      if (this.parentindex > 0) {
        /*   for (let i = 0; i < this.$refs.banvideo.length; i++) {
             this.$refs.banvideo[i].pause();
           }*/
        this.headHour = {
          top: "-80px"
        };
      } else {
        // this.$refs.banvideo[this.activeIndex].play();
        //
        this.headHour = {
          top: "0px"
        };
      }
      if (this.parentindex === 2) {
        this.endVal = 1998
      } else {
        this.endVal = 1
      }
    },
      // _isMobile() {
      // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // return flag;
      getEquipment() {
      let equ = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      console.log(equ);
        if (equ) {
          this.showMobile = true;
          // alert("手机端");
          if (this.$route.path == "/"){
            console.log(this.$route.name)
            console.log("222211111")
            // this.$router.push({
            //   path:"/mobile"
            // })
          }
          this.showPage="1"
          // this.$router.replace('/mobile');
        }else {

          this.showPc = true;
          console.log("pc端")
          this.showPage="2"
          // this.$router.replace('/');
          // alert("pc端");
        }
    }
  },
  }
</script>

<style lang="scss">
.el-menu-vertical-demo{
  width: 282px;
  .el-submenu__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-menu-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
  body,div,p,h1,h2,h3,h4,h5,h6,ul,li,dl,dt,a,input,button,textarea,select{
    margin: 0;
    padding: 0;
    outline: none;
  }
  body{
    color: #333333;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 45%;
    line-height: 1.43;
      min-width: 100%;
    // min-width: 1226px;
    font-size: 14px;
  }
  a{
    text-decoration: none;
  }
  ul,li{
    list-style: none;
  }
  input:focus,a:focus{
    outline: none;
  }
  #app{
    //overflow: hidden;
  }
</style>
